import React from 'react';
import PropTypes from 'prop-types';
import {
  FastField,
  useFormikContext,
} from 'formik';
import {
  Checkbox,
  FormControlLabel,
} from '@mui/material';

import fieldName, { heightUnitId, questionFieldName } from '../../../../formFields';
import externalText from '../../../../texts';
import {
  Container,
  SingleRowContainer,
  ShortFormInput,
  LongFormInput,
} from '../styles';

import { ParentContainer } from '../NameQuestion/styles';
import texts from './texts.json';

const LengthQuestion = ({ index, disabled }) => {
  const { setFieldValue } = useFormikContext();

  const fieldBaseName = `${fieldName.FIELDS}.${index}`;

  return (
    <Container>
      <ParentContainer>
        <SingleRowContainer>
          <ShortFormInput
            name={`${fieldBaseName}.${questionFieldName.UNITS}`}
            label={externalText.labels[questionFieldName.UNITS]}
            disabled
          />
          <FastField name={`${fieldBaseName}.${questionFieldName.REQUIRED}`}>
            {({ field }) => (
              <FormControlLabel
                key={`${fieldBaseName}-${index}-${questionFieldName.REQUIRED}`}
                control={<Checkbox checked={field.value} />}
                label={externalText.labels[questionFieldName.REQUIRED]}
                name={questionFieldName.REQUIRED}
                disabled={disabled}
                onChange={(event) => {
                  setFieldValue(`${fieldBaseName}.${questionFieldName.REQUIRED}`, event.target.checked);
                }}
              />
            )}
          </FastField>
        </SingleRowContainer>
        <LongFormInput
          name={`${fieldBaseName}.${questionFieldName.LABEL}`}
          label={externalText.labels[questionFieldName.LABEL]}
          disabled={disabled}
        />
        <LongFormInput
          name={`${fieldBaseName}.${questionFieldName.SUB_TEXT}`}
          label={externalText.labels[questionFieldName.SUB_TEXT]}
          disabled={disabled}
        />
        <SingleRowContainer>
          <ShortFormInput
            name={`${fieldBaseName}.${questionFieldName.UNIT_IDS}.${heightUnitId.FEET}`}
            label={texts.feet}
            disabled={disabled}
          />
          <ShortFormInput
            name={`${fieldBaseName}.${questionFieldName.UNIT_IDS}.${heightUnitId.INCHES}`}
            label={texts.inches}
            disabled={disabled}
          />
          <ShortFormInput
            name={`${fieldBaseName}.${questionFieldName.UNIT_IDS}.${heightUnitId.CM}`}
            label={texts.cm}
            disabled={disabled}
          />
        </SingleRowContainer>
      </ParentContainer>
    </Container>
  );
};

LengthQuestion.propTypes = {
  index: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
};

LengthQuestion.defaultProps = {
  disabled: false,
};

export default LengthQuestion;
